/**
 * 사용 설명서 본문 — **정본은 `manualGuide.json` 한 벌**(2026-10-01 way 「업데이트할 때마다 직원이 보는 실시간 매뉴얼」 · YDYOPS `/manual` 참조).
 *
 * 🔴 왜 코드(저장소)에 두나: 본문을 DB·문서에 따로 두면 화면을 고치는 사람이 같이 안 고쳐 한 달이면 멈춘다(YDYOPS 08-07 신고).
 *    저장소에 두면 **배포할 때마다 같이 나가고**, 화면을 고친 커밋에서 이 파일을 함께 고칠 수 있다.
 * 🔴 같은 JSON 을 PPT 설명서(`docs/staff-guide/_slides*.cjs`)도 읽는다 — 웹과 PPT 가 갈리지 않는다.
 * 🔴 `menu` 는 `App.tsx` NAV 의 메뉴 이름 그대로, `shot` 은 `public/manual/<shot>.webp` 가 있어야 한다
 *    — `pnpm -C apps/web manual-check` 가 둘 다 대조한다(메뉴 이름을 바꾸면 빨개진다).
 * 화면 사진은 `docs/staff-guide/_capture.mjs`(로컬 DB·가짜 이름) → `scripts/manual-shots.mjs` 로 줄여 넣는다.
 */
import data from './manualGuide.json';
import type { Screen } from './me';

export type ManualNote = { tone: 'amber' | 'red'; text: string };

export interface ManualSection {
  id: string;
  title: string;
  /** 상단 메뉴 이름(NAV label). 「공통」이면 메뉴와 무관. */
  menu: string;
  /** 이 화면을 볼 수 있는 사람에게만 기본으로 보인다(없으면 전원). */
  screen?: Screen;
  shot: string;
  steps: string[];
  note?: ManualNote;
}

export interface ManualPart {
  id: string;
  title: string;
  desc: string;
  sections: ManualSection[];
}

export const MANUAL: ManualPart[] = (data as { parts: ManualPart[] }).parts;
